import React from 'react'

export const ReplyIcon = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2453 0.00310903C5.73084 -0.121311 2.0324 3.50465 2.0324 8.00155H0.444819C0.0457067 8.00155 -0.149415 8.48146 0.134398 8.75696L2.6089 11.2454C2.78628 11.4231 3.06122 11.4231 3.23861 11.2454L5.71311 8.75696C5.99692 8.48146 5.79293 8.00155 5.40268 8.00155H3.80623C3.80623 4.53556 6.62663 1.73611 10.1033 1.78054C13.4027 1.82498 16.1787 4.60666 16.2231 7.91268C16.2674 11.3876 13.4736 14.2226 10.0147 14.2226C8.58672 14.2226 7.26521 13.7338 6.21865 12.9073C5.86388 12.6318 5.36721 12.6584 5.04792 12.9784C4.67541 13.3605 4.70202 13.9826 5.11887 14.3114C6.46698 15.369 8.16987 16 10.0147 16C14.4936 16 18.1211 12.2941 17.9969 7.77049C17.8816 3.60241 14.4049 0.118642 10.2453 0.00310903Z"
      fill="#6B6B6B"
    />
    <path
      d="M12.0867 7.70809L8.84756 5.83797C8.58089 5.684 8.24756 5.87645 8.24756 6.18437V9.92463C8.24756 10.2325 8.58089 10.425 8.84756 10.271L12.0867 8.40091C12.3533 8.24695 12.3533 7.86205 12.0867 7.70809Z"
      fill="white"
      stroke="#6B6B6B"
    />
  </svg>
)
